import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react-pro';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import styles from './styles';
import fetchRequest from 'src/network';
import './tncModal.css';

const OTPModal = ({
    msg,
    otp,
    setOtp,
    handleCloseTnC,
    resendOtp
}) => {
    const [isResending, setIsResending] = useState(false);

    const handleResend = async (e) => {
        e?.preventDefault();
        if (isResending) return;
        setIsResending(true);

        try {
            let res;
            if (typeof resendOtp === 'function') {
                res = await resendOtp();
            } else {
                res = await fetchRequest?.get('/user/tnc');
            }

            if (res?.status_code === 200 || res?.status === 200) {
                toast.success(res?.message || 'OTP resent successfully!');
            } else {
                toast.error(res?.message || res?.error_message || 'Failed to resend OTP. Please try again.');
            }
        } catch (error) {
            toast.error(error?.message || error?.error_message || 'Failed to resend OTP. Please try again.');
        } finally {
            setIsResending(false);
        }
    };

    return (
        <div>
            <CModal
                fullscreen={"md"}
                backdrop="static"
                alignment="center"
                size={'lg'}
                visible={true}
                aria-labelledby="StaticBackdropExampleLabel"
            >
                <CModalHeader closeButton={false}>
                    <CModalTitle id='StaticBackdropExampleLabel'>Verify OTP</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <div>
                        <p>{msg}</p>
                    </div>
                    <div className="d-flex justify-content-center gap-2">
                        {[...Array(4)].map((_, idx) => (
                            <input
                                key={idx}
                                type="text"
                                maxLength={1}
                                style={styles?.optInputField}
                                value={otp?.[idx] || ''}
                                onChange={e => {
                                    const val = e.target.value.replace(/[^0-9]/g, '');
                                    let newOtp = otp ? [...otp] : Array(4).fill('');
                                    newOtp[idx] = val;
                                    setOtp(newOtp);
                                    // Move to next input if value entered
                                    if (val && idx < 5) {
                                        document.getElementById(`otp-input-${idx + 1}`)?.focus();
                                    }
                                }}
                                onKeyDown={e => {
                                    if (e.key === 'Backspace' && !otp?.[idx] && idx > 0) {
                                        document.getElementById(`otp-input-${idx - 1}`)?.focus();
                                    }
                                }}
                                id={`otp-input-${idx}`}
                                autoComplete="off"
                            />
                        ))}
                    </div>
                </CModalBody>
                <CModalFooter>
                    <div className='d-flex w-100 justify-content-between align-items-center'>
                        <a
                            href="#resend"
                            onClick={handleResend}
                            className={`text-decoration-underline ${isResending ? 'text-muted pe-none' : 'text-primary'}`}
                            style={{ cursor: isResending ? 'not-allowed' : 'pointer' }}
                        >
                            {isResending ? 'Resending OTP...' : 'Resend OTP'}
                        </a>
                        <CButton
                            color="primary"
                            onClick={handleCloseTnC}
                        >
                            Done
                        </CButton>
                    </div>
                </CModalFooter>
            </CModal>
        </div>
    );
};

export default OTPModal;